<template>

  <div class="comp-article">
    <div class="comp-box">
      <div v-for="datum in compareData" v-bind:key="datum.key"  class="comp-column-box">
        <ul>

            <li class="comp-column-title">{{ datum.key1 }}<br>×<br>{{ datum.key2 }}<br>（{{ datum.count }}）</li>

            <v-tooltip top v-for="item in datum.items" v-bind:key="item.identifier">
            <template v-slot:activator="{ on }">
              <li id="mouseon" class="comp-sbox"  v-on="on">
                <div class="thumbnail"><router-link :to="'\/uuid\/' + item.identifier"><img v-bind:src="item.screen" alt="" /></router-link></div>
              </li>
            </template>
            <span>
              <h4><span v-for="c in item.subject" v-bind:key="c">{{ c }}&nbsp;</span></h4>
              <p>{{ item.description }}</p>
              <p>撮影日時：{{item.created | dateFormatter}}<br>撮影場所：{{item.spatial}}</p>
              <p>投稿者　：<span v-for="c in item.creator"  v-bind:key="c">{{ c }}</span><br>投稿日　：{{item.dateSubmitted| dateFormatter}}</p>
            </span>
          </v-tooltip>

          <template v-if="false">
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
          </li>
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
            </li>
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
            </li>
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
            </li>
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
            </li>
            <li id="mouseon" class="comp-sbox">
              <div class="thumbnail"><a href="detail.html" target="_blank"><img src="../assets/logo.png" alt="" /></a></div>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
 export default {
     computed: {
         compareData: function(){
             console.log(this.$store.state.comparedata.length);
             return this.$store.state.comparedata;
         },

     },
     created(){
     },

     methods:{
     }
 }
</script>
<style>
 /*---------------------------------

    comp-box

    ----------------------------------*/

 .comp-wrapper {
     overflow: hidden;
     width: 100%;
     overflow-x: scroll;
     overflow-y: hidden; 
 }

 .comp-contents {
     margin: 25px;
     position: relative;
 }

 .comp-contents .side{
     position: absolute;
     top:0;
     left: 0;
 }

 .comp-article {
     padding: 0 20px 0 0;
     width: 1656px;
 }


 .comp-box {
     margin: 10px auto ;
 }

 .comp-column-box {
     float: left;
     white-space:nowrap;
     padding: 0 15px;
     border-right: 1px dotted #bbb;
 }

 .comp-column-box:first-child {
     padding-left: 0;
 }
 .comp-column-box:last-child {
     border: none;
     padding-right: 0;
 }

 .comp-column-title {
     text-align: center;
     font-size: 110%;
     margin-bottom: 10px;
 }

 .comp-sbox {
     width: 250px;
     margin: 0 0 15px 0;
     background-color: #fff;
     /*box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);*/
 }


 .comp-column-boxr {
     margin-right: 0;
     padding-right: 0;
     border-right: none;
 }

</style>
